import SectionLabel from "../common/SectionLabel";
import ProjectCard from "./ProjectCard";
import { projects } from "../../data/projects";

function SelectedWork() {
  return (
    <section id="work" className="divider">
      <div className="wrap">
        <SectionLabel label="selected work" />
        <div className="project-grid">
          {projects.map((project) => (
            <ProjectCard project={project} key={project.slug} />
          ))}
        </div>
        <p className="hint hint-hover">
          hover or focus a card to see the technical decision behind it
        </p>
      </div>
    </section>
  );
}

export default SelectedWork;
